import { render, staticRenderFns } from "./p35.vue?vue&type=template&id=16e60105&scoped=true&"
import script from "./p35.vue?vue&type=script&lang=js&"
export * from "./p35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e60105",
  null
  
)

export default component.exports